import { Icon, Icons } from '@silverfort/sf-components';

const BannerThemes = {
    Info: {
        className: 'bg-sf-primary-100 border border-sf-primary-500 rounded-xl',
        icon: <Icon icon={Icons.CircleInfo} className="text-sf-primary-500" />
    },
    Attention: {
        className: 'bg-sf-neutral-100 border border-sf-neutral-500 rounded-xl',
        icon: <Icon icon={Icons.Warning} className="text-sf-neutral-500" />
    },
    Critical: {
        className: 'bg-sf-negative-100 border border-sf-negative-500 rounded-xl',
        icon: <Icon icon={Icons.ShieldWarning} className="text-sf-negative-500" />
    },
    Success: {
        className: 'bg-sf-positive-100 border border-sf-positive-500 rounded-xl',
        icon: <Icon icon={Icons.CircleCheck} className="text-sf-positive-500" />
    }
};

export default BannerThemes;
